export default "<div class=\"background\">\n    <!-- <h1>Deloitte<span class=\"dot\">.</span></h1> -->\n</div>\n"